var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[{ 'balko-badge': !_vm.small }, { 'balko-badge-small': _vm.small }]},[_c('div',{class:[
      { 'balko-badge-icon': !_vm.small },
      { 'balko-badge-icon-small': _vm.small }
    ]},[_c('b-img',{class:[{ 'icon-size': _vm.small }],attrs:{"src":("/static/icons/" + _vm.iconName)}})],1),_vm._v(" "),(_vm.text)?_c('div',{class:[
      { 'balko-badge-text': !_vm.small },
      { 'balko-badge-text-small': _vm.small }
    ]},[_c('span',[_vm._v("\n      "+_vm._s(_vm.text)+"\n    ")])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }